module.exports = __webpack_public_path__ + "static/media/arrow-up.79ef25ed.svg";